import React from 'react';
import Icon from './Icon';
import {IconProps} from './IconProps';

export default function IconLinkedin({className, height, title}: IconProps) {
  return (
    <Icon className={className} height={height} title={title}>
      M6.125 16V6.65625H3.21875V16H6.125ZM4.65625 5.40625C5.59375 5.40625 6.34375 4.625 6.34375 3.6875C6.34375 2.78125
      5.59375 2.03125 4.65625 2.03125C3.75 2.03125 3 2.78125 3 3.6875C3 4.625 3.75 5.40625 4.65625 5.40625ZM16.9688
      16H17V10.875C17 8.375 16.4375 6.4375 13.5 6.4375C12.0938 6.4375 11.1562 7.21875 10.75
      7.9375H10.7188V6.65625H7.9375V16H10.8438V11.375C10.8438 10.1562 11.0625 9 12.5625 9C14.0625 9 14.0938 10.375
      14.0938 11.4688V16H16.9688Z</Icon>
  );
}
